import { render } from "./wxPay.vue?vue&type=template&id=583151f7"
import script from "./wxPay.vue?vue&type=script&lang=js"
export * from "./wxPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__